import React, { useState } from "react";
import { Theme } from "@mui/material/styles";
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";

interface Props {
  title: string;
  id: string;
  body: React.ReactNode;
  defaultExpand: boolean;
  setExpandToState: (id: string, state: boolean) => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      "width": "100%",
      "boxShadow": "none",
      "borderBottom": "1px solid #acc8df",
      "& .MuiAccordionSummary-expandIcon": {
        paddingTop: 0,
        paddingBottom: 0,
        height: "1rem",
      },
    },
    summaryStyles: {
      "padding": "8px 0",
      "width": "100%",
      "backgroundColor": theme.palette.secondary.main,
      "&.MuiButtonBase-root.MuiAccordionSummary-root": {
        minHeight: "0px",
        paddingTop: "1rem",
        paddingBottom: "1rem",
      },
      "& > div.MuiAccordionSummary-content": {
        "margin": 0,
        "& h4": { margin: 0 },
      },
      "&.Mui-focusVisible": {
        "backgroundColor": theme.palette.secondary.main,
        "& > .MuiAccordionSummary-expandIcon": {
          backgroundColor: "rgba(0, 0, 0, 0.08)",
        },
      },
    },
    body: {
      "backgroundColor": theme.palette.secondary.main,
      "padding": "0rem 0rem .5rem 0rem",
      "display": "block",
      "& > div:last-child": { paddingBottom: 0 },
    },
    heading: {
      lineHeight: "1rem",
      fontWeight: 700,
      padding: 0,
    },
  }),
);

export default function AccordionDropdown({
  title,
  body,
  id,
  defaultExpand,
  setExpandToState,
}: Props) {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(defaultExpand);

  const handleChange = () => {
    setExpanded(!expanded);
    setExpandToState(`${id}Expand`, !expanded);
  };
  return (
    <Accordion
      defaultExpanded={defaultExpand}
      onChange={handleChange}
      expanded={expanded}
      className={classes.wrapper}
      square={true}
    >
      <AccordionSummary
        className={classes.summaryStyles}
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${id}-content`}
        id={`${id}-header`}
      >
        <Typography variant="h4" className={classes.heading}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.body}>{body}</AccordionDetails>
    </Accordion>
  );
}
